export default {
  'component.portalVersion.tip': 'Keep the current page and refresh the navigation',
  'component.portalVersion.classic': 'Classic',
  'component.portalVersion.v2': 'New',
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
};
